export const errors = {
  CREDENCIALES_INCORRECTAS: 'El CUIL/CUIT o la contraseña es incorrecta',
  CREDENCIALES_INCORRECTAS_DNI: 'El DNI es incorrecto',
  NO_AUTORIZADO_ST: 'USUARIO NO AUTORIZADO',
  ERROR_AL_RESERVAR: 'HUBO UN PROBLEMA AL INTENTAR RESERVAR, PRUEBE CON OTRO TURNO',
  USUARIO_EXISTENTE: 'EL USUARIO YA EXISTE',
  CONTRASEÑA_INCORRECTA: 'LA CONTRASEÑA QUE INGRESO ES INCORRECTA',
};
